import React, { useState, useEffect } from 'react';
import '../css/moodboard-media-view.css';
import Img from 'react-cool-img';
import ReactJWPlayer from 'react-jw-player';
import ThumbnailVimeo from './ThumbnailVimeo';
import ThumbnailYouTube from './ThumbnailYouTube';
import ThumbnailAudio from './ThumbnailAudio';
import ThumbnailImage from './ThumbnailImage';
import ThumbnailVideo from './ThumbnailVideo';
import ContentComments from './ContentComments';

export default function MoodboardMediaView(props) {

    const [playingUrl, setPlayingUrl] = useState(null);
    const [playingItem, setPlayingItem] = useState(null);
    const [selectedMoodboard, setSelectedMoodboard] = useState(null);

    useEffect(() => {
        setTimeout(() => {
            if (document.querySelector('.thumbs .video-thumbnail')) {
                document.querySelector('.thumbs .video-thumbnail').click();
            }
        }, 500);
    }, []);

    const setPlaying = item => {
        setPlayingUrl(null);
        setPlayingItem(null);
        if (item.type === 'video') {
            if (item.fileUrl.includes('vimeo') && !item.fileUrl.includes('player.vimeo')) {
                const id = item.fileUrl.split('/').pop();
                setPlayingUrl(`https://player.vimeo.com/video/${id}`);
            } else if (item.fileUrl.includes('youtube')) {
                const id = new URL(item.fileUrl).searchParams.get('v');
                setPlayingUrl(`https://www.youtube.com/embed/${id}`);
            } else {
                setPlayingUrl(item.fileUrl);
            }
        } else {
            setPlayingUrl(item.fileUrl);
        }

        setPlayingItem(item);
        setSelectedMoodboard(item._id);
    }

    const renderThumbnails = () => {
        if (props.moodboards) {
            if (props.moodboards.length > 0) {
                return props.moodboards
                    .sort((a, b) => parseInt(a.order) - parseInt(b.order))
                    .map(item => {
                        if (item.type && item.fileUrl) {
                            if (item.type === 'video') {
                                if (item.fileUrl.includes('vimeo'))
                                    return <ThumbnailVimeo key={item._id} item={item} setPlaying={setPlaying} />
                                else if (item.fileUrl.includes('youtube'))
                                    return <ThumbnailYouTube key={item._id} item={item} setPlaying={setPlaying} />
                                else if (item.fileUrl.includes('filmboard.s3'))
                                    return <ThumbnailVideo key={item._id} item={item} setPlaying={setPlaying} />
                            } else if (item.type === 'audio') {
                                return <ThumbnailAudio key={item._id} item={item} setPlaying={setPlaying} />
                            } else if (item.type === 'image') {
                                return <ThumbnailImage key={item._id} item={item} setPlaying={setPlaying} />
                            } else if (item.type === 'website') {
                                return <ThumbnailImage key={item._id} item={item} setPlaying={setPlaying} />
                            } else if (item.type === 'pexels-video') {
                                return <ThumbnailVideo key={item._id} item={item} setPlaying={setPlaying} />
                            }
                        }
                    });
            }
            else {
                return <div className="container-fluid text-center not-found">No moodboards found.</div>;
            }
        }
        else {
            return <div className="container-fluid text-center not-found">No moodboards found.</div>;
        }
    }

    const renderDisplaying = () => {
        if (playingItem) {
            const type = playingItem.type;
            if (type === 'video') {
                if (playingUrl.includes('youtube') || playingUrl.includes('vimeo'))
                    return <iframe id="player" className="player" src={playingUrl} key={playingUrl} frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
                else
                    return <ReactJWPlayer
                        className="player"
                        playerId={playingUrl.toString()}
                        playerScript='https://cdn.jwplayer.com/libraries/s7lNp89j.js'
                        file={playingUrl}
                        image={playingItem.thumbnailUrl}
                    />
                // return <video className="player" controls key={playingUrl}>
                //     <source src={playingUrl} type="video/mp4" />
                // </video>
            } else if (type === 'audio') {
                return <div style={{ margin: '20px', marginTop: '100px' }} key={playingUrl}>
                    <audio controls className="audio-player" src={playingUrl}></audio>
                </div>
            } else if (type === 'image') {
                //return <img className="image-player" key={playingUrl} src={playingUrl} />
                return <Img
                    className="image-player"
                    key={playingUrl}
                    src={playingUrl}
                />
            } else if (type === 'website') {
                return <>
                        <Img
                        className="image-player mb-30"
                        key={playingUrl}
                        src={playingUrl}
                    />
                    Title: {playingItem.title}<br/>
                    Website: <a href={playingItem.websiteUrl} target="_blank" className="btn btn-link">{playingItem.websiteUrl}</a><br/>
                    Description: {playingItem.description}
                    </>
            } else if (type === 'pexels-video') {
                return <ReactJWPlayer
                    className="player"
                    playerId={playingUrl.toString()}
                    playerScript='https://cdn.jwplayer.com/libraries/s7lNp89j.js'
                    file={playingUrl}
                    image={playingItem.thumbnailUrl}
                />
                // return <video className="player" key={playingUrl} controls>
                //     <source src={playingUrl} type="video/mp4" />
                // </video>
            }
        }
        else {
            return <div className="container-fluid text-center not-found">No moodboards found.</div>;
        }
    }

    return (
        <div className="container-fluid text-center mt-20">
            <div className="row">
                <div className="col-2 col-sm-1 col-md-1 text-center thumbs thumbnails-col">
                    {renderThumbnails()}
                </div>
                <div className="col-10 col-sm-11 col-md-8 text-left media-view-col">
                    {renderDisplaying()}
                </div>
                <div className="col-12 col-sm-12 col-md-3 text-left" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                    {selectedMoodboard && <ContentComments id={selectedMoodboard} />}
                </div>
            </div>
        </div>
    );
}